import { render, staticRenderFns } from "./LicenceExpired.vue?vue&type=template&id=35581230&scoped=true"
import script from "./LicenceExpired.vue?vue&type=script&lang=js"
export * from "./LicenceExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35581230",
  null
  
)

export default component.exports